import { Editor } from "@tiptap/react";
import { PRINT_STYLES } from "./constants";

export const getCurrentPageNumber = (editor: Editor) => {
    const containers = editor.$nodes("page");
    const currentPageIndex =
        containers?.findIndex(
            (container) =>
                editor.state.selection.$anchor.pos >= container.from &&
                editor.state.selection.$anchor.pos <= container.to
        ) || 0;
    return currentPageIndex + 1;
};

export const cleanContent = (content: string) => {
    // Remove image wrapper if present
    return content.replace(
        /<span class="react-renderer node-imageComponent"[^>]*><div class="image-component"[^>]*>(.*?)<\/div><\/span>/g,
        "$1"
    );
};

export const printDocument = (editor: Editor) => {
    if (!editor) return;
    const content = cleanContent(editor.view.dom.innerHTML);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    iframe.contentDocument?.write(`
            <html>
                <head>
                    <title>Print Document</title>
                    <style>
                        ${PRINT_STYLES}
                    </style>
                </head>
                <body>${content}</body>
            </html>
        `);
    iframe.contentDocument?.close();

    if (iframe.contentWindow) {
        iframe.contentWindow.onafterprint = () => {
            document.body.removeChild(iframe);
        };
    }

    iframe.contentWindow?.print();
};

export const getHTMLWithPageBreaks = (html: string): string => {
    return html.replace(
        /(<\/div>)(\s*<div[^>]*class="[^"]*page[^"]*"[^>]*>)/g,
        '<div data-type="page-break" class="page-break"></div>$1$2'
    );
};
